import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Tab, Tabs, Typography } from '@mui/material';

const ElfPaymentsLayout: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const tabIndex = pathname.includes('/check-batches') ? 1 : 0;

  const handleTab = (_: React.SyntheticEvent, newValue: number) => {
    const routes = ['paypal', 'check-batches'];
    navigate(`/finance/elf-payments/${routes[newValue]}`);
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>
        ELF Payments
      </Typography>
      <Tabs value={tabIndex} onChange={handleTab} sx={{ mb: 2 }}>
        <Tab label="PayPal" />
        <Tab label="Check batches" />
      </Tabs>
      <Outlet />
    </Box>
  );
};

export default ElfPaymentsLayout;
